import React from 'react';
import Table from 'lib/src/components/table/Table';
import useFetchAllChallengeAssessments from './_hooks/useFetchAssessmentChallenges';
import { Column } from 'lib/src/types/table';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import DataCheck from 'lib/src/components/common/DataCheck';
import { isEmpty } from 'lib/src/utils/generic';
import dayjs from 'dayjs';
import { AssessmentChallenge } from 'src/types/shared/Assessments';

const AssessmentChallengesTable = () => {
    const { assessmentChallenges, isFetching, fetchError } = useFetchAllChallengeAssessments();

    return (
        <DataCheck
            dataExists={!isEmpty(assessmentChallenges)}
            isFetching={isFetching}
            noDataMessage="No challenges found"
            error={fetchError}
            errorMessage={typeof fetchError === 'string' ? fetchError : 'Error fetching challenges'}
        >
            <Table columns={columns} rows={assessmentChallenges} isLoading={false} />
        </DataCheck>
    );
};

const columns: Column<AssessmentChallenge>[] = [
    {
        key: 1,
        heading: 'Name',
        getValue: row => `${row.name}`,
        searchable: true,
    },
    {
        key: 2,
        heading: 'Start date',
        getValue: row => dayjs(row.startDate).format('DD/MM/YYYY'),
    },
    {
        key: 3,
        heading: 'End date',
        getValue: row => dayjs(row.endDate).format('DD/MM/YYYY'),
    },
    {
        key: 4,
        heading: '',
        getValue: row => (
            <ButtonRow alignment="right">
                <p className="flex-row align-center status">
                    {row.requiresAssessmentFromUser ? (
                        <>
                            <i className="far fa-times" />
                            <span>&nbsp;Entries require assessment</span>
                        </>
                    ) : (
                        <>
                            <i className="far fa-check" />
                            <span>&nbsp;All entries assessed</span>
                        </>
                    )}
                </p>
                <LinkButton color="green" icon="search" href={`/assessments/challenge/${row.id}`}>
                    View details
                </LinkButton>
                <LinkButton color="grey" icon="pencil" href={`/assessments/submissions/${row.id}`}>
                    View submissions
                </LinkButton>
            </ButtonRow>
        ),
    },
];

export default AssessmentChallengesTable;
